export default "__VITE_ASSET__DvbMC2at__"